import React, { useState } from 'react';
import './App.css';
import Layout from './components/Layout';
import Home from './components/Home';
import Charitra from './components/Charitra';
import Dathalu from './components/Dathalu';
import Media from './components/Media';

function App() {
  const [currentPage, setCurrentPage] = useState(() => sessionStorage.getItem('currentPage') || 'home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Media State
  const [mediaItems, setMediaItems] = useState([]);
  const [selectedMediaId, setSelectedMediaId] = useState('');

  const navigateTo = (page) => {
    setCurrentPage(page);
    sessionStorage.setItem('currentPage', page);
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const renderContent = () => {
    switch (currentPage) {
      case 'home':
        return <Home onNavigate={navigateTo} />;
      case 'charitra':
        return <Charitra />;
      case 'dathalu':
        return <Dathalu />;
      case 'media':
        return null; // Media component is rendered globally
      default:
        return <Home onNavigate={navigateTo} />;
    }
  };

  return (
    <Layout
      currentPage={currentPage}
      onNavigate={navigateTo}
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={setIsMenuOpen}
    >
      <Media
        mediaItems={mediaItems}
        setMediaItems={setMediaItems}
        selectedMediaId={selectedMediaId}
        setSelectedMediaId={setSelectedMediaId}
        isVisible={currentPage === 'media'}
      />
      {renderContent()}
    </Layout>
  );
}

export default App;
